import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: require("./locales/en.json"),
      },
      fi: {
        translation: require("./locales/fi.json"),
      },
      sv: {
        translation: require("./locales/sv.json"),
      },
      // is: {
      //   translation: require("./locales/is.json"),
      // },
    },
  });

export default i18n;
